import { render, staticRenderFns } from "./IcoMenuHome.vue?vue&type=template&id=1789d16d&lang=html"
import script from "./IcoMenuHome.vue?vue&type=script&lang=js"
export * from "./IcoMenuHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports